import React, { useState, useEffect, Fragment } from 'react'
import { useParams } from 'react-router'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import ProductSwiper from './ProductSwiper'
import ProductTag from './ProductTag'
import ContactForm from './ContactForm'
import ProductIcon from './ProductIcon'
import ProductMap from './ProductMap'

const useStyles = makeStyles((theme) => ({
	mainContainer : {
		margin: "1em auto",
		justifyContent: "center",
		[theme.breakpoints.down('sm')]: {
			maxWidth: "100%",
		},
		[theme.breakpoints.between('md','lg')]: {
			maxWidth: "90%",
		},
		[theme.breakpoints.up('lg')]: {
			maxWidth: 1024,
		},
	},
	container : {
		background: "white",
		padding: "1.5em",
		marginBottom: "1.5em",
		borderRadius: 30,
	},
	miniContainer: {
		display: "flex",
		marginBottom:"2em",
		flexWrap: "wrap"
	},
	productTitle : {
		fontWeight: 500, 
		margin: "0 .5em", 
		textTransform: "uppercase",
		[theme.breakpoints.down(600)]: {
			fontSize: "1.7rem"
		},
	},
	formTitle : {
		background: theme.palette.primary.main,
		color: "white",
		padding: "1em 1.5em",
		textAlign: "center",
	},
	contactProfile : {
		display: "flex",
		alignItems: "center",
		[theme.breakpoints.down('xs')]: {
			justifyContent: "center",
		},
	},
	contactImg : {
		background: theme.palette.text.primary,
		borderRadius: "100%",
		height: 75,
		width: 75,
	},
	contactInfo : {
		display: "grid",
		alignItems: "center",
		justifyContent: "flex-start",
		gap: "0.5em",

		[theme.breakpoints.down('xs')]: {
			justifyContent: "center",
		},
	},
	mapDesk : {
		display: "block",
		width: "100%",
		[theme.breakpoints.down(600)] : {
			display: "none",
		}
	},
	mapMobile : {
		display: "none",
		marginBottom: "1.5rem",
		width: "100%",
		padding: "0px !important",
		[theme.breakpoints.down(600)] : {
			display: "block",
		}
	},
	contactEmail : {
		maxWidth: 185,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		"&:hover" : {
			width: "auto",
			overflow:"visible",
		}
	},
	tags : {
		display: "flex",
		[theme.breakpoints.down(960)]: {
			display: "contents",
		},	
	},
	stickyElement : {
		[theme.breakpoints.up(769)]: {
			position: "sticky",
			top:20, 
		},
	},
    linkWpps: {
        textDecoration: "none",
        color: "#00873a",
        display: "flex",
        alignItems: "center"
    }
}))

export default function Product(props) {
	var propiedades = useSelector((state) => state.properties)
	const classes = useStyles()
	const { codOferta, codInmobiliaria } = useParams()

    var numberFormat = new Intl.NumberFormat('es-ES')
		
	const [loading, setLoading] = useState(true)
	const [success, setSuccess] = useState(true)
	const [oferta, setOferta] = useState([])
	const [propiedad, setPropiedad] = useState([])
	const [lat, setLat] = useState()
	const [lng, setLng] = useState()
	const [caracArray, setCaracArray] = useState([])

    const [contador, setContador] = useState(false)

	useEffect(() => {
		propiedades?setOferta(propiedades.Ofertas.find(e => e.CodOferta === codOferta)):setTimeout(() => {
            setContador(!contador)
        }, 3000)
		
	}, [ contador ]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const getPropiedad = async () => {
			const response = await fetch(`${window.location.protocol}//api.topinmobiliario.com/consultaroferta.php?CodInmobiliaria=${codInmobiliaria}&CodOferta=${codOferta}&usuario=EV1&clave=chascomus`)
			const dataPropiedad = await response.json()

			if(JSON.stringify(dataPropiedad) !== '{"Error":"No se encontro la oferta."}'){
				setPropiedad(dataPropiedad)
			
				setLat( parseFloat(dataPropiedad[0].Latitud) )
				setLng( parseFloat(dataPropiedad[0].Longitud) )

				var carac = dataPropiedad[0].Caracteristicas
				var caracA = []
				for (var key in carac) {
					caracA.push(
						<Fragment key={key}>
							<Grid item xs={6} sm={4}>
								<Typography variant="body2" color="textPrimary" style={{display: "list-item", margin:"0 10px 0 5px"}}>
									<b>{key}:</b> {carac[key]}
								</Typography>
							</Grid>
						</Fragment>
					)
				}
				setCaracArray(caracA)

				setLoading(false)
			}else{
				setSuccess(false)
			}
		}
		getPropiedad()
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ loading ])

	return (
		<div>
			{success ?
			<Grid container spacing={3} className={classes.mainContainer}>

				<Grid item xs={12} sm={8}>
					{loading ?
						<>
							<Skeleton animation="wave" height={80} width="90%" />
							<Skeleton animation="wave" height={30} width="50%" style={{margin: "-15px 0 10px 0"}} />
							<Skeleton animation="wave" variant="rect" height={300} width="100%" style={{marginBottom: 20}} />
							<div className={classes.container}>
								<Skeleton animation="wave" height={30} width="40%" />
								<Skeleton animation="wave" height={20} width="100%" />
								<Skeleton animation="wave" height={20} width="100%" />
								<Skeleton animation="wave" height={20} width="100%" />
								<Skeleton animation="wave" height={20} width="100%" />
							</div>
						</>
						:
						<>
							<Typography variant="h5" align="left" color="textSecondary" className={classes.productTitle}>
								{oferta.Titulo}
							</Typography>

							<Typography variant="subtitle2" align="justify" color="textPrimary" style={{margin: "0.6em 1.3em 1.5em", textTransform: "capitalize"}}>
								{propiedad[0].Calle} {propiedad[0].Altura},
								{" "+ propiedad[0].Area},
								{" "+ propiedad[0].Provincia},
								{" "+ propiedad[0].Pais}
							</Typography>
							{propiedad[0].Fotos !== null ? 
								<ProductSwiper fotos={propiedad[0].Fotos}/>
								:
								<div style={{minHeight: 200, display: "flex", justifyContent:"center", alignItems:"center"}}>
									<svg x="0px" y="0px" width="200" height="200" viewBox="0 0 172 172" style={{fill: "#000000"}}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{mixBlendMode: "normal"}}><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#b9b9b9"><path d="M46.44,32.68c-11.3786,0 -20.64,9.2614 -20.64,20.64v65.36c0,11.3786 9.2614,20.64 20.64,20.64h79.12c11.3786,0 20.64,-9.2614 20.64,-20.64v-65.36c0,-11.3786 -9.2614,-20.64 -20.64,-20.64zM46.44,36.12h79.12c9.5194,0 17.2,7.6806 17.2,17.2v65.36c0,9.5194 -7.6806,17.2 -17.2,17.2h-79.12c-9.5194,0 -17.2,-7.6806 -17.2,-17.2v-65.36c0,-9.5194 7.6806,-17.2 17.2,-17.2zM46.44,41.28c-6.63954,0 -12.04,5.40046 -12.04,12.04v43.73906c-0.01517,0.09232 -0.01517,0.1865 0,0.27883v21.34211c0,6.63954 5.40046,12.04 12.04,12.04h69.53906c0.09232,0.01517 0.1865,0.01517 0.27883,0h9.30211c6.63954,0 12.04,-5.40046 12.04,-12.04v-7.57539c0.01667,-0.09671 0.01667,-0.19556 0,-0.29227v-18.79234c0.00439,-0.31015 -0.15856,-0.59863 -0.42645,-0.75498c-0.26789,-0.15635 -0.59921,-0.15635 -0.8671,0c-0.26789,0.15635 -0.43084,0.44484 -0.42645,0.75498v16.84391l-21.39922,-21.39922c-0.97495,-0.97495 -2.26117,-1.46469 -3.54078,-1.46469c-1.27961,0 -2.56583,0.48974 -3.54078,1.46469l-16.23922,16.23922l-28.27922,-28.27922c-0.97495,-0.97495 -2.26117,-1.46469 -3.54078,-1.46469c-1.27961,0 -2.56583,0.48974 -3.54078,1.46469l-19.67922,19.67922v-41.78391c0,-5.71006 4.60994,-10.32 10.32,-10.32h71.38c0.31015,0.00439 0.59863,-0.15856 0.75498,-0.42645c0.15635,-0.26789 0.15635,-0.59921 0,-0.8671c-0.15635,-0.26789 -0.44484,-0.43084 -0.75498,-0.42645zM114.38,55.04c-3.08167,0 -5.50069,1.18659 -7.09164,2.97641c-1.59095,1.78982 -2.36836,4.14248 -2.36836,6.48359c0,2.34111 0.77741,4.69378 2.36836,6.48359c1.59095,1.78982 4.00998,2.97641 7.09164,2.97641c5.21443,0 9.46,-4.24557 9.46,-9.46c0,-5.21443 -4.24557,-9.46 -9.46,-9.46zM114.38,56.76c4.28487,0 7.74,3.45513 7.74,7.74c0,4.28487 -3.45513,7.74 -7.74,7.74c-2.65167,0 -4.53264,-0.96341 -5.80836,-2.39859c-1.27572,-1.43518 -1.93164,-3.38252 -1.93164,-5.34141c0,-1.95889 0.65592,-3.90622 1.93164,-5.34141c1.27572,-1.43518 3.15669,-2.39859 5.80836,-2.39859zM136.72656,70.50656c-0.22809,0.00356 -0.44542,0.09758 -0.60418,0.26138c-0.15876,0.1638 -0.24595,0.38397 -0.24238,0.61205v3.44c-0.00439,0.31015 0.15856,0.59863 0.42645,0.75498c0.26789,0.15635 0.59921,0.15635 0.8671,0c0.26789,-0.15635 0.43084,-0.44484 0.42645,-0.75498v-3.44c0.00364,-0.23275 -0.08721,-0.45703 -0.25181,-0.62163c-0.1646,-0.1646 -0.38888,-0.25545 -0.62163,-0.25181zM59.34,75.68c0.84287,0 1.6794,0.31549 2.32469,0.96078l28.76633,28.76633c0.06522,0.09788 0.14983,0.18135 0.24859,0.24523l23.3443,23.34766h-67.58391c-5.71006,0 -10.32,-4.60994 -10.32,-10.32v-21.14391l20.89531,-20.89531c0.64529,-0.64529 1.48181,-0.96078 2.32469,-0.96078zM136.72656,79.10656c-0.22809,0.00356 -0.44542,0.09758 -0.60418,0.26138c-0.15876,0.1638 -0.24595,0.38397 -0.24238,0.61205v6.88c-0.00439,0.31015 0.15856,0.59863 0.42645,0.75498c0.26789,0.15635 0.59921,0.15635 0.8671,0c0.26789,-0.15635 0.43084,-0.44484 0.42645,-0.75498v-6.88c0.00364,-0.23275 -0.08721,-0.45703 -0.25181,-0.62163c-0.1646,-0.1646 -0.38888,-0.25545 -0.62163,-0.25181zM110.94,87.72c0.84287,0 1.6794,0.31549 2.32469,0.96078l22.61531,22.61531v7.38391c0,5.71006 -4.60994,10.32 -10.32,10.32h-9.10391l-24.08,-24.08l16.23922,-16.23922c0.64529,-0.64529 1.48181,-0.96078 2.32469,-0.96078z"></path></g></g></svg>
								</div>
							}

							<div className={classes.container}>
								<div className={classes.miniContainer} style={{justifyContent:"space-between"}}>
									<div className={classes.tags}>
										<ProductTag title={propiedad[0].TipoOperacion} tag={propiedad[0].TipoOperacion} />
										<ProductTag title={propiedad[0].Subproducto} tag="normal" />
										<ProductTag title={propiedad[0].Area} tag="normal" />
									</div>
									<Typography color="textSecondary" variant="caption">
										Código: <b>{codInmobiliaria} {propiedad[0].CodigoOferta}</b>
									</Typography>
								</div>
								<div style={{marginBottom:"2em"}}>
									{propiedad[0].Precio <= 1 
										? <Typography variant="h5" color="primary" component="p" style={{fontWeight:"bold"}}>
											Consultar precio
										</Typography>
										: <>
											<Typography variant="h5" color="primary" component="p" style={{fontWeight:"bold"}}>
												{propiedad[0].Moneda} {numberFormat.format(propiedad[0].Precio)}
											</Typography>
											{(propiedad[0].TipoOperacion === "Alquiler") ? <span>/mensual</span> : ""}
										</>
									}
								</div>
								<div className={classes.miniContainer} style={{marginBottom:0}}>
									<ProductIcon 
										id="m2total" 
										info={propiedad[0].Caracteristicas["Superficie total"] ? 
											propiedad[0].Caracteristicas["Superficie total"] 
											: "-"} 
										title mr mb/>
									<ProductIcon 
										id="m2cubierta" 
										info={propiedad[0].Caracteristicas["Superficie cubierta"] ? 
											propiedad[0].Caracteristicas["Superficie cubierta"] 
											: "-"} 
										title/>
								</div>
							</div>

							<div className={classes.container}>
								<Typography variant="subtitle2" color="textSecondary" style={{marginBottom:"1em"}}>
									Descripción
								</Typography>
								<Typography variant="body2" color="textPrimary" >
									{propiedad[0].Destacable}
								</Typography>
							</div>

							<div className={classes.container} style={{marginBottom:0}}>
								<Typography variant="subtitle2" color="textSecondary" style={{marginBottom:"1em"}}>
									Características generales
								</Typography>
								
								<Grid container style={{margin: "0 10px"}}>
									{caracArray}
								</Grid>
							</div>
							
						</>
					}

				</Grid>

				<Grid item xs={12} className={classes.mapMobile}>
					<div>
						{loading ? 
							<Skeleton animation="wave" variant="rect" height={400} width="100%" />
							: 
							<ProductMap 
								lat={lat}
								lng={lng}
								tipoOp={propiedad[0].TipoOperacion} 
								direc={`${propiedad[0].Calle} ${propiedad[0].Altura}`}
								ciudad={propiedad[0].Area}
								prov={propiedad[0].Provincia}
								pais={propiedad[0].Pais}
							/>
						}
					</div>
				</Grid>

				<Grid item xs={12} sm={4} >
					<div className={classes.stickyElement}>
						<div className={classes.formTitle} style={{borderRadius: "30px 30px 0 0"}}>
							<Typography variant="h6">Consultar por esta propiedad</Typography>
						</div>
						<div className={classes.container} style={{borderRadius: "0 0 30px 30px", paddingTop:0}}>
							{loading?
								<ContactForm asunto={'Cargando...'} />
								:
								<ContactForm asunto={'Consulta por oferta codigo: '+ propiedad[0].CodigoOferta} />
							}
						</div>

						<div className={classes.container}>
							<div className={classes.contactProfile}>
								{loading
									? (
										<Skeleton animation="wave" variant="circle" height={60} width={60} style={{marginRight:10}} />
									) 
									: (
                                        <svg x="0px" y="0px" width="100" height="100" viewBox="0 0 172 172" fill="#000000">
                                            <g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{mixBlendMode: "normal"}}>
                                                <path d="M0,172v-172h172v172z" fill="none"></path>
                                                <g>
                                                    <circle cx="50" cy="50" transform="scale(1.72,1.72)" r="35" fill="#00873a"></circle>
                                                    <path d="M49.02,76.54v30.96c0,2.85004 2.30996,5.16 5.16,5.16h49.88c2.85004,0 5.16,-2.30996 5.16,-5.16v-30.96c0,-2.85004 -2.30996,-5.16 -5.16,-5.16h-49.88c-2.85004,0 -5.16,2.30996 -5.16,5.16z" fill="#ffffff"></path>
                                                    <path d="M109.22,100.62h8.6c2.85004,0 5.16,-2.30996 5.16,-5.16v-30.96c0,-2.85004 -2.30996,-5.16 -5.16,-5.16h-49.88c-2.85004,0 -5.16,2.30996 -5.16,5.16v6.02" fill="#ffffff"></path>
                                                    <path d="M74.82,104.06c0,-5.94776 -2.98936,-10.94952 -7.04168,-12.39776h-4.83664c-4.05232,1.44824 -7.04168,6.45 -7.04168,12.39776v0.86h18.92z" fill="#f1c40f"></path>
                                                    <circle cx="38" cy="50" transform="scale(1.72,1.72)" r="3.5" fill="#f1c40f"></circle>
                                                    <g fill="#000000">
                                                        <path d="M86,147.92c-34.14372,0 -61.92,-27.77628 -61.92,-61.92c0,-34.14372 27.77628,-61.92 61.92,-61.92c34.14372,0 61.92,27.77628 61.92,61.92c0,34.14372 -27.77628,61.92 -61.92,61.92zM86,27.52c-32.24656,0 -58.48,26.23344 -58.48,58.48c0,32.24656 26.23344,58.48 58.48,58.48c32.24656,0 58.48,-26.23344 58.48,-58.48c0,-32.24656 -26.23344,-58.48 -58.48,-58.48z"></path>
                                                        <path d="M112.66,41.67044c-0.14964,0 -0.301,-0.03784 -0.43688,-0.11868c-1.10596,-0.65188 -2.2446,-1.26936 -3.38496,-1.83352c-0.42656,-0.21156 -0.60028,-0.72584 -0.39044,-1.1524c0.21156,-0.42828 0.731,-0.59684 1.1524,-0.39044c1.17992,0.58308 2.35468,1.2212 3.49504,1.89544c0.40936,0.24252 0.54524,0.76884 0.30444,1.1782c-0.15996,0.27004 -0.44548,0.4214 -0.7396,0.4214z"></path>
                                                        <path d="M117.82,45.14828c-0.18232,0 -0.36636,-0.05848 -0.52288,-0.17716c-0.55384,-0.42484 -1.11972,-0.83764 -1.69076,-1.23668c-0.38872,-0.27348 -0.48332,-0.81012 -0.20984,-1.19884c0.27004,-0.38872 0.80668,-0.4816 1.19712,-0.21156c0.59168,0.41452 1.17476,0.84108 1.74924,1.2814c0.3784,0.28724 0.44892,0.82732 0.16168,1.20572c-0.17028,0.22188 -0.42656,0.33712 -0.68456,0.33712z"></path>
                                                        <path d="M86,139.32c-29.40168,0 -53.32,-23.92004 -53.32,-53.32c0,-29.39996 23.91832,-53.32 53.32,-53.32c6.30552,0 12.48204,1.0922 18.35584,3.24564c0.4472,0.1634 0.67596,0.65704 0.51256,1.10252c-0.1634,0.4472 -0.6622,0.67768 -1.10424,0.51084c-5.6846,-2.08292 -11.65988,-3.139 -17.76416,-3.139c-28.45224,0 -51.6,23.14776 -51.6,51.6c0,28.45224 23.14776,51.6 51.6,51.6c28.45224,0 51.6,-23.14776 51.6,-51.6c0,-14.51508 -6.1662,-28.4402 -16.91792,-38.20636c-0.3526,-0.31992 -0.3784,-0.86344 -0.05848,-1.21432c0.32164,-0.3526 0.86516,-0.37668 1.21432,-0.05848c11.1112,10.09124 17.48208,24.48076 17.48208,39.47916c0,29.39996 -23.91832,53.32 -53.32,53.32z"></path>
                                                        <path d="M104.06,113.52h-49.88c-3.3196,0 -6.02,-2.7004 -6.02,-6.02v-30.96c0,-3.3196 2.7004,-6.02 6.02,-6.02h49.88c3.3196,0 6.02,2.7004 6.02,6.02v30.96c0,3.3196 -2.7004,6.02 -6.02,6.02zM54.18,72.24c-2.37188,0 -4.3,1.92984 -4.3,4.3v30.96c0,2.37016 1.92812,4.3 4.3,4.3h49.88c2.37188,0 4.3,-1.92984 4.3,-4.3v-30.96c0,-2.37016 -1.92812,-4.3 -4.3,-4.3z"></path>
                                                        <path d="M117.82,101.48h-8.6v-1.72h8.6c2.37188,0 4.3,-1.92984 4.3,-4.3v-30.96c0,-2.37016 -1.92812,-4.3 -4.3,-4.3h-49.88c-2.37188,0 -4.3,1.92984 -4.3,4.3v6.02h-1.72v-6.02c0,-3.3196 2.7004,-6.02 6.02,-6.02h49.88c3.3196,0 6.02,2.7004 6.02,6.02v30.96c0,3.3196 -2.7004,6.02 -6.02,6.02z"></path>
                                                        <path d="M100.62,82.56h-18.92c-0.47472,0 -0.86,-0.38528 -0.86,-0.86c0,-0.47472 0.38528,-0.86 0.86,-0.86h18.92c0.47472,0 0.86,0.38528 0.86,0.86c0,0.47472 -0.38528,0.86 -0.86,0.86z"></path>
                                                        <path d="M93.74,89.44h-12.04c-0.47472,0 -0.86,-0.38528 -0.86,-0.86c0,-0.47472 0.38528,-0.86 0.86,-0.86h12.04c0.47472,0 0.86,0.38528 0.86,0.86c0,0.47472 -0.38528,0.86 -0.86,0.86z"></path>
                                                        <path d="M100.62,89.44h-3.44c-0.47472,0 -0.86,-0.38528 -0.86,-0.86c0,-0.47472 0.38528,-0.86 0.86,-0.86h3.44c0.47472,0 0.86,0.38528 0.86,0.86c0,0.47472 -0.38528,0.86 -0.86,0.86z"></path>
                                                        <path d="M100.62,96.32h-18.92c-0.47472,0 -0.86,-0.38528 -0.86,-0.86c0,-0.47472 0.38528,-0.86 0.86,-0.86h18.92c0.47472,0 0.86,0.38528 0.86,0.86c0,0.47472 -0.38528,0.86 -0.86,0.86z"></path>
                                                        <path d="M88.58,103.2h-6.88c-0.47472,0 -0.86,-0.38528 -0.86,-0.86c0,-0.47472 0.38528,-0.86 0.86,-0.86h6.88c0.47472,0 0.86,0.38528 0.86,0.86c0,0.47472 -0.38528,0.86 -0.86,0.86z"></path>
                                                        <path d="M95.46,103.2h-3.44c-0.47472,0 -0.86,-0.38528 -0.86,-0.86c0,-0.47472 0.38528,-0.86 0.86,-0.86h3.44c0.47472,0 0.86,0.38528 0.86,0.86c0,0.47472 -0.38528,0.86 -0.86,0.86z"></path>
                                                        <path d="M100.62,103.2h-1.72c-0.47472,0 -0.86,-0.38528 -0.86,-0.86c0,-0.47472 0.38528,-0.86 0.86,-0.86h1.72c0.47472,0 0.86,0.38528 0.86,0.86c0,0.47472 -0.38528,0.86 -0.86,0.86z"></path>
                                                        <path d="M74.82,104.92c-0.47472,0 -0.86,-0.38528 -0.86,-0.86c0,-5.461 -2.66084,-10.22712 -6.47064,-11.58936c-0.44892,-0.15996 -0.68112,-0.65188 -0.52116,-1.09908c0.15996,-0.44548 0.65016,-0.68112 1.09908,-0.51944c4.48404,1.60132 7.61272,7.03308 7.61272,13.20788c0,0.47472 -0.38528,0.86 -0.86,0.86zM55.9,104.92c-0.47472,0 -0.86,-0.38528 -0.86,-0.86c0,-6.1748 3.12868,-11.60656 7.61272,-13.20788c0.45064,-0.16168 0.93912,0.07396 1.09908,0.51944c0.15996,0.4472 -0.07224,0.93912 -0.52116,1.09908c-3.8098,1.36224 -6.47064,6.12836 -6.47064,11.58936c0,0.47472 -0.38528,0.86 -0.86,0.86z"></path>
                                                        <path d="M65.36,92.88c-3.79432,0 -6.88,-3.08568 -6.88,-6.88c0,-3.79432 3.08568,-6.88 6.88,-6.88c3.79432,0 6.88,3.08568 6.88,6.88c0,3.79432 -3.08568,6.88 -6.88,6.88zM65.36,80.84c-2.84488,0 -5.16,2.31512 -5.16,5.16c0,2.84488 2.31512,5.16 5.16,5.16c2.84488,0 5.16,-2.31512 5.16,-5.16c0,-2.84488 -2.31512,-5.16 -5.16,-5.16z"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
									)
								}
								{loading
									? (
										<Fragment>
											<Skeleton animation="wave" height={50} width="70%" />
										</Fragment>
									) 
									: (
										<Fragment>
											<div style={{marginLeft:"1em"}}>
												<Typography variant="body2">NÚMEROS Y CORREO DE CONTACTO</Typography>
												{/** <Typography variant="subtitle2">Germán Bergagno</Typography> */}
											</div>
										</Fragment>
									)
								}
							</div>
							{loading
								? (
									<Fragment>
										<Skeleton animation="wave" height={20} width="100%" />
										<Skeleton animation="wave" height={20} width="100%" />
										<Skeleton animation="wave" height={20} width="100%" />
									</Fragment>
								) 
								: (
									<Fragment>
										<div className={classes.contactInfo}>
											{/* <Typography variant="body2">(0362) 4450222<br/></Typography> */}
											<Typography variant="body2">
												<b><a className={classes.linkWpps} href={"https://wa.me/+5493644698336"} target="_blank" rel="noreferrer">Alquileres - Sáenz Peña<svg viewBox="0 0 24 24" width="18px" height="18px" fill="#00873a"><path d="M19,21H5c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h7v2H5v14h14v-7h2v7C21,20.1,20.1,21,19,21z"/><path d="M21 10L19 10 19 5 14 5 14 3 21 3z"/><path d="M6.7 8.5H22.3V10.5H6.7z" transform="rotate(-45.001 14.5 9.5)"/></svg></a></b>
											</Typography>
											<Typography variant="body2">
												<b><a className={classes.linkWpps} href={"https://wa.me/+5493644525305"} target="_blank" rel="noreferrer">Ventas - Sáenz Peña<svg viewBox="0 0 24 24" width="18px" height="18px" fill="#00873a"><path d="M19,21H5c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h7v2H5v14h14v-7h2v7C21,20.1,20.1,21,19,21z"/><path d="M21 10L19 10 19 5 14 5 14 3 21 3z"/><path d="M6.7 8.5H22.3V10.5H6.7z" transform="rotate(-45.001 14.5 9.5)"/></svg></a></b>
											</Typography>
											<Typography variant="body2">
												<b><a className={classes.linkWpps} href={"https://wa.me/+5493624283820"} target="_blank" rel="noreferrer">Alquileres - Resistencia<svg viewBox="0 0 24 24" width="18px" height="18px" fill="#00873a"><path d="M19,21H5c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h7v2H5v14h14v-7h2v7C21,20.1,20.1,21,19,21z"/><path d="M21 10L19 10 19 5 14 5 14 3 21 3z"/><path d="M6.7 8.5H22.3V10.5H6.7z" transform="rotate(-45.001 14.5 9.5)"/></svg></a></b>
											</Typography>
											<Typography variant="body2">
												<b><a className={classes.linkWpps} href={"https://wa.me/+5493624283839"} target="_blank" rel="noreferrer">Ventas - Resistencia<svg viewBox="0 0 24 24" width="18px" height="18px" fill="#00873a"><path d="M19,21H5c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h7v2H5v14h14v-7h2v7C21,20.1,20.1,21,19,21z"/><path d="M21 10L19 10 19 5 14 5 14 3 21 3z"/><path d="M6.7 8.5H22.3V10.5H6.7z" transform="rotate(-45.001 14.5 9.5)"/></svg></a></b>
											</Typography>

											<Typography variant="body2" className={classes.contactEmail}>
												<b>Email: </b>{propiedad[0].Inmobiliaria[0].Email}
											</Typography>
										</div>
									</Fragment>	
								)
							}
						</div>
					</div>
				</Grid>

			</Grid>
			:
			<Grid container spacing={3} className={classes.mainContainer}>
				<Grid item xs={12} sm={8}>
					<Typography variant="h5" align="center" color="textSecondary" className={classes.productTitle}>
						No se encontró oferta
					</Typography>
				</Grid>
			</Grid>
			}
			
			<div className={classes.mapDesk}>
				{loading ? 
					<Skeleton animation="wave" variant="rect" height={400} width="100%" />
					: <ProductMap lat={lat} lng={lng} tipoOp={propiedad[0].TipoOperacion} />
				}
			</div>

		</div>
	)
}
